import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import { FaPhone, FaEnvelope } from 'react-icons/fa';

import Layout from '../Layout';
import Seo from '../component/Seo';
import { langPathSuffix } from '../lang-utils';
import { findService } from '../services-config';

const HOME_LABEL = { lt: 'Pradžia', en: 'Home', ru: 'Главная' };

function ServiceDetailPage({ lang = 'lt' }) {
  const { slug } = useParams();

  return (
    <Layout
      lang={lang}
      renderChildren={({ strings }) => {
        const service = findService(slug);

        if (!service) {
          return (
            <>
              <Seo path={`/paslaugos/${slug}/`} lang={lang} title={strings.notfound.header} description="" />
              <Container className="section-padding text-center">
                <h1>{strings.notfound.header}</h1>
                <p>{strings.notfound.message}</p>
                <Link to={`/paslaugos/${langPathSuffix(lang)}`}>
                  {strings.service.backToServices}
                </Link>
              </Container>
            </>
          );
        }

        const t = service.seo[lang] || service.seo.lt;

        return (
          <>
            <Seo
              path={`/paslaugos/${slug}/`}
              lang={lang}
              title={t.title}
              description={t.description}
              pageName={t.h1}
              parentPage={{
                name: strings.navbar.service,
                path: '/paslaugos/'
              }}
            />

            <Container className="section-padding">
              {/* Visual breadcrumb */}
              <nav aria-label="breadcrumb" className="mb-3">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={`/${langPathSuffix(lang)}`}>
                      {HOME_LABEL[lang] || HOME_LABEL.lt}
                    </Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to={`/paslaugos/${langPathSuffix(lang)}`}>
                      {strings.navbar.service}
                    </Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    {t.h1}
                  </li>
                </ol>
              </nav>

              {/* H1 + underline */}
              <div className="text-center">
                <h1 className="section-title">{t.h1}</h1>
                <div className="section-underline" />
              </div>

              {/* Description */}
              <p className="text-justify page-intro">{t.intro}</p>

              {/* Photo placeholder grid */}
              <Row className="g-3 mt-3 mb-4">
                <Col xs={12} md={6}>
                  <div className="photo-placeholder">
                    <span className="photo-placeholder-icon">📷</span>
                    <span>{strings.service.photoPlaceholder}</span>
                  </div>
                </Col>
                <Col xs={12} md={6}>
                  <div className="photo-placeholder">
                    <span className="photo-placeholder-icon">📷</span>
                    <span>{strings.service.photoPlaceholder}</span>
                  </div>
                </Col>
              </Row>

              {/* Contact CTA */}
              <div className="service-description">
                <div className="text-center text-padding-top">
                  {strings.service.callmenow}:
                </div>
                <div className="text-center">
                  <div className="fa-phone-270 inline">
                    <FaPhone />
                  </div>
                  <div className="call-me inline">
                    &nbsp; +&#51;&#55;&#48; 6&#55;304&#55;2&#55;
                  </div>
                </div>
                <div className="text-center text-padding-top">
                  {strings.service.mailmenow}:
                </div>
                <div className="text-center">
                  <div className="fa-mail-2 inline">
                    <FaEnvelope />
                  </div>
                  <div className="call-me inline">
                    &nbsp; kaunetraliukas&#64;&#103;&#109;ai&#108;.com
                  </div>
                </div>
              </div>

              {/* Cross-links */}
              <ul className="cross-links mt-4">
                <li>
                  <Link to={`/paslaugos/${langPathSuffix(lang)}`}>
                    {strings.service.backToServices}
                  </Link>
                </li>
                <li>
                  <Link to={`/duk/${langPathSuffix(lang)}`}>{strings.navbar.faq}</Link>
                </li>
                <li>
                  <Link to={`/galerija/${langPathSuffix(lang)}`}>{strings.navbar.gallery}</Link>
                </li>
                <li>
                  <Link to={`/kontaktai/${langPathSuffix(lang)}`}>{strings.navbar.contact}</Link>
                </li>
              </ul>
            </Container>
          </>
        );
      }}
    />
  );
}

export default ServiceDetailPage;
